var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wave-charts"},[_c('div',{staticClass:"chart-row"},[_c('div',{ref:"uChartContainer",staticClass:"chart-item"}),_c('div',{ref:"iChartContainer",staticClass:"chart-item"})]),(!_vm.uData.length && !_vm.iData.length)?_c('div',{staticClass:"no-data-tip"},[_vm._v(" 暂无数据，请刷新重试 ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }